import styled from 'styled-components'
import { PROVABLY_FORM_STYLED_PROPS } from './interface'

export const Button = styled.div<PROVABLY_FORM_STYLED_PROPS>`
  background: ${({ colors }) => colors.secondary};
  border: solid 3px ${({ colors }) => colors.secondary};
  border-radius: 38px;
  height: 56px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${({ colors }) => colors.primary};
  text-transform: uppercase;
  font-size: 18px;
  margin: 20px 0;
  position: relative;
  transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
  transition: transform 0.167s;
  ${({ anim }) => (anim ? 'transform: scale(0.65);' : 'transform: scale(1); ')}
  cursor: pointer;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  :after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    transition-timing-function: cubic-bezier(0.33, 1, 0, 0);
    transition: opacity 0.167s;
    ${({ anim }) => (anim ? 'opacity: 0.5;' : '')}
  }
`

export const SeedInput = styled.input<PROVABLY_FORM_STYLED_PROPS>`
  font-family: 'GT America, regular';
  background: transparent;
  border: solid 3px;
  border-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  outline: none;
  height: 56px;
  font-size: 20px;
  border-color: ${({ seedError, colors }) =>
    seedError ? colors.secondaryText : colors.secondary};
  transition: all 0.333s linear;
  ${({ seedError, colors }) =>
    seedError
      ? `border-color: ${colors.secondaryText}; color: ${colors.secondaryText};`
      : `border-color: ${colors.secondary}; color: ${colors.secondary};`}
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  &::placeholder {
    color: ${({ seedError, colors }) =>
      seedError ? colors.secondaryText : colors.secondary};
    transition: all 0.333s linear;
  }
`
